<div class="body-app">
  <div class="login-body">
    <div class="login-logo-app">
      <img src="assets/images/logo-meep.png" alt="Meep">
    </div>
    <form>
        <app-input [inputModel]="recoveryPasswordModel.novaSenhaInputModel" (isInputValid)="setFormStatus($event, 'senha')" [(value)]="recoveryPasswordModel.novaSenha"></app-input>
        <app-input [inputModel]="recoveryPasswordModel.confirmacaoNovaSenhaInputModel" (isInputValid)="setFormStatus($event, 'confirmarSenha')" [(value)]="recoveryPasswordModel.confirmacaoNovaSenha"></app-input>
        <div class="button-row">
        <button mat-button class="buttonEnter" (click)="recoveryPasswordValidation()">Cadastrar nova senha</button>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/recovery-password/recovery-password.component.html